import * as React from "react";

export const fields = (t) => ({
    config: {columns: 2},
    fields: [
        {
            name: "productionStartDate",
            label: t ? t("common.start_date") : "Data startu",
            column: 2,
        },
        {
            name: "productionStartUsername",
            label: t ? t("common.user_started") : "Użytkownik wystartował",
            column: 2,
        },
        {
            name: "productionEndDate",
            label: t ? t("common.end_date") : "Data końca",
            column: 2,
        },
        {
            name: "productionEndUsername",
            label: t ? t("common.user_finished") : "Użytkownik zakończył",
            column: 2,
        },
        {
            name: "quantity",
            label: t ? t("forms.produced_packages") : "Ilość wyprodukowanych opakowań",
            sort: "desc",
            column: 2,
        },

        {
            name: "seriesNumber",
            label: t ? t("forms.series_number") : "Numer serii",
            column: 1,
        },
        {
            name: "productName",
            label: t ? t("forms.product_name") : "Nazwa produktu",
            column: 1,
        },
        {
            name: "seriesNumber",
            label: t ? t("forms.series_number") : "Numer serii",
            column: 1,
        },
        {
            name: "orderNumber",
            label: t ? t("forms.order_number") : "Numer zlecenia",
            column: 1,
        },
        {
            name: "gmidNumber",
            label: "GMID",
            sort: "desc",
            column: 1,
        },
        {
            name: "productionStartComment",
            label: t ? t("forms.start_comments") : "Uwagi przy rozpoczęciu",
            type: "textarea",
            column: 1,
        },

        {
            name: "endComment",
            label: t ? t("forms.end_comments") : "Uwagi przy zakończeniu",
            type: "textarea",
            column: 2,
        },
    ]
});
